import { SlotGameType1_3 } from "../SlotGameType1_3"
// namespace SlotGames3
// {
	export class CloverGirlGoldFillingPot3 extends SlotGameType1_3
	{
	}
// }